import 'material-design-icons-iconfont/dist/material-design-icons.css' // Ensure you are using css-loader
import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.css'
import colors from 'vuetify/es5/util/colors'

// process.env = require('./../../config/prod.env')

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    options: {
      customProperties: true
    },
    themes: {
      light: {
        white: '#ffffff',
        primary: colors.blueGrey.base,
        primary_light: colors.blueGrey.lighten5,
        secondary: colors.blueGrey.darken4,
        grey: colors.grey.base,
        grey_light: colors.grey.lighten5,
        grey_line: colors.grey.lighten1,
        alert: '#E91E63',
        success: '#41b883',
        accent: colors.indigo.base,
        deep_orange: colors.deepOrange.base,
        app_primary: process.env.VUE_APP_PRIMARY_COLOR,
        app_secondary: process.env.VUE_APP_SECONDARY_COLOR,
        app_tertiary: process.env.VUE_APP_TERTIARY_COLOR,
        app_quaternary: process.env.VUE_APP_QUATERNARY_COLOR,
        app_cluster: process.env.VUE_APP_CLUSTER_COLOR,
        app_geojson: process.env.VUE_APP_GEOJSON_COLOR,
        app_menu_item: process.env.VUE_APP_MENU_ITEM_COLOR,
        app_menu_item_active: process.env.VUE_APP_MENU_ITEM_ACTIVE_COLOR,
        app_logo_background: process.env.VUE_APP_LOGO_BACKGROUND_COLOR,
        app_topbar_background: process.env.VUE_APP_TOPBAR_BACKGROUND_COLOR,
        app_footer_background: process.env.VUE_APP_FOOTER_BACKGROUND_COLOR,
        app_footer_text: process.env.VUE_APP_FOOTER_TEXT_COLOR,
        app_header_name_color: process.env.VUE_APP_NAME_COLOR,
        // stratif by region
        africa: colors.blue.darken4,
        asiaandpacific: colors.green.base,
        cee: colors.red.base,
        grulac: colors.purple.base,
        weog: colors.amber.base,
        internationalwaters: colors.lightBlue.lighten1,
        // stratif by site type
        urban: colors.indigo.base,
        suburban: colors.indigo.lighten2,
        rural: colors.green.base,
        remote: colors.amber.base,
        highaltitude: colors.deepOrange.base,
        polar: colors.lightBlue.lighten4,
        notclassified: colors.grey.darken1,
        background: colors.brown.darken3,
        impacted: colors.orange.darken3,
        // trends
        increasing: '#e60055',
        decreasing: '#64b42d',
        insignificant: '#00aae1',
        notavailable: colors.grey.darken1,
        not_available: colors.grey.darken1,
        not_enough_data_limit: colors.grey.lighten1,
        // chart color scale
        low: colors.lightGreen.base,
        middle: colors.yellow.base,
        hight: colors.deepOrange.accent3
      }
    }
  },
  icons: {
    iconfont: 'md'
  }
})



// WEBPACK FOOTER //
// ./src/plugins/vuetify.js